module.exports = __webpack_public_path__ + "img/docUpload.0e51fcdc.svg";